import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate, Link, useLocation } from 'react-router-dom';
import style from '../../../css/Product.module.css';
import { fetchAllProducts1 } from "../../../components/Service/ProductService.js";
import Server from './Server.js';
// import Packages from './Packages.js';
// import Operating from './Operating.js';
// import Circle from './Circle.js';

// import Invoice from '../../Bill/Bill2.js';
import Backups from './Backup.js';
import Cookies from 'js-cookie';
import { useRegion } from "../../../Context/RegionsContext.js";
import { BillContext } from '../../Bill/BillContext.js';
import deburr from 'lodash/deburr';
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import LoadingSpinner from '../../../css/Loading.js';
// import Backup2 from './Backup2.js';

const Invoice = React.lazy(() => import('../../Bill/Bill2.js'));
const Backup2 = React.lazy(() => import('./Backup2.js'));
const Packages = React.lazy(() => import('./Packages.js'));
const Operating = React.lazy(() => import('./Operating.js'));
// const Server = React.lazy(() => import('./Server.js'));
const Circle = React.lazy(() => import('./Circle.js'));

const Parent = React.memo(({ selectedLanguage }) => {
    const [server, setServer] = useState([]);
    const [regions, setregions] = useState([]);
    const { selectedRegion } = useRegion(); // Sử dụng RegionContext
    const [packages, setSelectedPackage] = useState([]);//1
    const [serverchose, setserverchose] = useState([]);//1
    const [circleChose, setcircleChose] = useState([]);//1
    const [pricebackup, setpricebackup] = useState(null);
    const [selectedChildSystem, setselectedChildSystem] = useState(null);
    const [selectednameversion, setselectednameversion] = useState(null);
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [cookieData, setCookieData] = useState({});

    const [hostname, sethostname] = useState(null);
    const [error, setError] = useState(false); // Trạng thái lỗi
    const { t, i18n } = useTranslation();


    useEffect(() => {
        const language = localStorage.getItem('language') || 'en';
        i18n.changeLanguage(language);
    }, [i18n]);


    const handleChildError = (error) => {
        setError(error); // Cập nhật lỗi
    };

    // console.log("selectedRegion", selectedRegion)

    //Danh Sách Tuyền hóa đơn


    const [pricekm, setpriceKM] = useState(0);

    const [isChecked, setIsChecked] = useState(false);

    const [backup, setbackup] = useState("");


    const { totalAmount, calculateTotal, baseAmount, taxAmount, postdiscount, backupPrice } = useContext(BillContext); // Sử dụng BillContext

    // const saveToCookies = (key, id) => {
    //     Cookies.set(key, id, {expires: 7 });
    // };
    const handleClickTypeBackup = (type) => {
        setbackup(type);
    }


    // console.log("backupne", backup)
    useEffect(() => {
        // if (packages) {
        //     setcircleChose({
        //         cycle: "monthly",
        //         price: packages.monthly,
        //         months: 1,
        //     });
        // }
        // console.log("circleChose", circleChose)
    }, [packages]);
    // console.log("packages", packages)

    // useEffect(() => {
    //     if (packages && circleChose) {
    //         calculateTotal(packages, circleChose, pricebackup, pricekm, backup);
    //     }
    // }, [packages, circleChose, pricebackup, pricekm, calculateTotal, backup]);


    // console.log("selectedRegion", selectedRegion.slug)
    // console.log("circleChose", circleChose)


    useEffect(() => {
        if (packages && circleChose && pricebackup) {
            calculateTotal(packages, circleChose, pricebackup, pricekm);
        }
    }, [packages, circleChose, pricebackup, pricekm, calculateTotal, selectedRegion]);
    const [loading, setLoading] = useState(true);



    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await fetchAllProducts1(selectedRegion.slug);
                const data = response?.systems || [];
                setServer(data || []);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        if (selectedRegion) {
            fetchData();
        }
    }, [selectedRegion]);



    // console.log("server", server)



    // console.log("regions", regions)
    useEffect(() => {
        updateURLFromCookies();

        const params = new URLSearchParams(window.location.search);

        const serverId = params.get("server");
        const packageId = params.get("package");
        const cycle = params.get("cycle");
        // const region = params.get("region");
        const discount = params.get("discount");
        const backupType = params.get("backup");
        const images = params.get("images");

        if (serverId) setserverchose({ id: serverId });
        if (packageId) setSelectedPackage({ id: packageId });
        if (cycle) setcircleChose({ cycle });
        // if (region) setregions(region);
        if (discount) setpriceKM(parseFloat(discount));
        if (backupType) setbackup(backupType);
        if (images) setselectedChildSystem(images);
    }, []);


    const updateURL = () => {
        const params = new URLSearchParams(window.location.search);

        if (selectedRegion && selectedRegion.slug) {
            params.set("region", selectedRegion.slug);
        } else {
            window.history.replaceState(null, "", window.location.pathname);
            return;
        }

        if (serverchose.id) params.set("server", serverchose.id);
        if (packages.id) params.set("package", packages.id);
        if (circleChose.cycle) params.set("cycle", circleChose.cycle);
        if (pricekm) params.set("discount", pricekm);
        if (backup) params.set("backup", backup);
        if (selectedChildSystem) params.set("images", selectedChildSystem);

        const newUrl = `?${params.toString()}`;

        window.history.replaceState(null, "", newUrl);

        return newUrl; // Trả về URL vừa được cập nhật
    };


    const updateURLFromCookies = () => {
        const params = new URLSearchParams(window.location.search);
        // const cookieString = Cookies.get("redirectURLPublic");
        const storageString = localStorage.getItem("redirectURLPublic");

        if (storageString) {
            const cookieParams = new URLSearchParams(storageString);
            let cookieObject = {};

            for (const [key, value] of cookieParams) {
                params.set(key, value);
                cookieObject[key] = value;
            }

            window.history.replaceState(null, "", `?${params.toString()}`);

            console.log("Updated URL:", window.location.href);
            setCookieData(cookieObject);
        } else {
            console.log("No redirectURLPublic cookie found.");
        }
    };



    useEffect(() => {
        const timer = setTimeout(() => {
            const newUrl = updateURL();

            if (newUrl) {
                localStorage.setItem('redirectURLPublic', newUrl);

                // Cookies.set("redirectURLPublic", newUrl, { expires: 7 });
                console.log("Saved to cookie:", newUrl);
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [serverchose, packages, circleChose, pricekm, backup, selectedChildSystem, selectedRegion]);




    const handleSelectedPackage = (pkg) => {
        setSelectedPackage(pkg);

    };

    const handleCycleChange = (cycle) => {
        setcircleChose(cycle);
    };
    const handleonPriceBackup = (price) => {
        setpricebackup(price);
    }
    useEffect(() => {
        console.log("pricebackup", pricebackup)

    }, [pricebackup]
    )

    const handleSelectedServer = (server) => {
        setserverchose(server);
    }


    const handleSelectedChildSystem = ({ filteredIds, type }) => {
        console.log("childchild", filteredIds)
        if (filteredIds && filteredIds.length > 0) {
            const selectedImageId = filteredIds[0];
            setselectedChildSystem(selectedImageId);
            // updateURL(selectedImageId);
        }
    };

    const handleselectNameVersionSystem = (child) => {
        setselectednameversion(child);

    }

    const handleSelectedFeatures = (features) => {
        setSelectedFeatures(features);
    };
    const handleXuLyGiaKhuyenMai = (priceKM) => {
        setpriceKM(priceKM)
    }
    const handleStatusChange = (status) => {
        setIsChecked(status); // Nhận trạng thái từ con
    };

    // console.log("isCheckedP", isChecked)
    const handleHostnameChange = (e) => {
        const rawValue = e.target.value;
        const normalizedValue = rawValue.normalize("NFD").replace(/[\u0300-\u036f]/g, '');
        const sanitizedValue = normalizedValue.replace(/[^a-zA-Z0-9\-\._]/g, '');
        if (sanitizedValue === '') {
            console.error('Không được để trống!');
            setError('Hostname không được để trống!');
        } else {
            setError('');
        }
        sethostname(sanitizedValue);
    };




    // useEffect(() => {
    //     saveToCookies("selectedRegion", selectedRegion?.id);
    // }, [selectedRegion]);



    useEffect(() => {
    }, [serverchose]);

    // useEffect(() => {
    //     saveToCookies("Package", packages?.id);
    // }, [packages]);




    // Cookies.set("Region", selectedRegion)
    console.log("serverchose", serverchose)
    if (loading) {
        return <LoadingSpinner />;
    }
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-xl-9 col-lg-9 mx-auto mb-4  " style={{
                        width: "78.16667%", // 9.5/12 * 100%
                    }}>
                        <div className="row">
                            <div className="d-flex align-items-center mb-3" style={{ position: "relative", margin: "0", padding: "0px" }}>
                                <div
                                    style={{
                                        width: "10px",
                                        height: "100%",
                                        backgroundColor: "#007bff",
                                        marginRight: "10px",
                                    }}
                                ></div>
                                <h5 className="m-0">{t("Deploy a Server")} CSSP</h5>
                            </div>
                            <div className="col-12 mx-1">
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>{t("Choose Type")} <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span></h5>
                                    </div>
                                    <Server
                                        server={server} onSelectedServer={handleSelectedServer}

                                    />
                                </div>
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>{t("Choose Image")} <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span>
                                        </h5>
                                    </div>
                                    <Operating serverchose={serverchose} onSelectedChildSystem={handleSelectedChildSystem} onselectNameVersionSystem={handleselectNameVersionSystem} cookieData={cookieData} />
                                </div>
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>{t("Choose Plan")}                                   <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span></h5>
                                    </div>
                                    <Packages circleChose={circleChose} serverchose={serverchose} onSelectedPackage={handleSelectedPackage} selectedChildSystem={selectedChildSystem} cookieData={cookieData}
                                    />
                                </div>
                                <div
                                    style={{
                                        color: error ? 'red' : 'black',
                                        fontWeight: 'bold',
                                        borderRadius: '5px',
                                        margin: 0,
                                        padding: 0
                                    }}
                                    className={style.section}
                                >


                                </div>


                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>{t("Choose Cycle")} <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span></h5>
                                    </div>
                                    <Circle selectedPackage={packages} onCycleChange={handleCycleChange} />
                                </div>
                                <div className={style.tiltleframe}>
                                    <h5>{t("Hostname")} <span style={{ color: "red", position: "relative", top: "-5px", fontSize: "15px" }}>*</span>
                                    </h5>

                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="domainHostingName"
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: 'bold',
                                            marginBottom: '5px',
                                        }}
                                    >
                                    </label>
                                    <input
                                        type="text"
                                        id="domainHostingName"
                                        className="form-control"
                                        placeholder={t("Please enter hostname")}
                                        style={{
                                            border: error ? '1px solid red' : '1px solid #ccc', // Khung đỏ nếu lỗi
                                            borderRadius: '5px',
                                            width: '100%',
                                            boxSizing: 'border-box',
                                        }}
                                        value={hostname}
                                        onChange={handleHostnameChange}
                                    />
                                    {/* {error && (
                                            <small style={{ color: 'red', fontWeight: 'bold' }}>
                                                Hostname không được để trống!
                                            </small>
                                        )} */}
                                </div>
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h5>{t("Backup")}
                                        </h5>
                                    </div>
                                    {/* <Backups onSelectedfeatures={handleSelectedFeatures} pricepermonth={pricepermonth} priceAdd={priceAdd} /> */}

                                    <Backup2 selectedCycle={circleChose} packages={packages} onPriceBackup={handleonPriceBackup}
                                    ></Backup2>
                                </div>
                                {/* <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h6>Auto Backup                                       </h6>
                                    </div>
                                    <Backup ontypeBackup={handleClickTypeBackup} backupPrice={backupPrice} pricepermonth={pricepermonth} />
                                </div> */}
                                {/* 
                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h6>Coupon</h6>
                                    </div>
                                    <Discount getPriceDiscount={handleXuLyGiaKhuyenMai} />
                                </div>

                                <div className={style.section}>
                                    <div className={style.tiltleframe}>
                                        <h6>Choose Payment Method                                        </h6>
                                    </div>
                                    <PaymentOptions onStatusChange={handleStatusChange} />
                                </div> */}


                            </div>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="col-12 col-lg-2 d-flex justify-content-end me-auto">
                        <div className="w-100">
                            <Invoice
                                onChildError={handleChildError} // Truyền hàm xử lý lỗi xuống con
                                packages={packages}
                                baseAmount={baseAmount}
                                totalAmount={totalAmount}
                                selectedproduct={serverchose}
                                selectedpackage={packages}
                                selectedCycle={circleChose}
                                selectedChildSystem={selectedChildSystem}
                                selectednameversion={selectednameversion}
                                selectedFeatures={selectedFeatures}
                                taxAmount={taxAmount}
                                pricekm={pricekm}
                                isChecked={isChecked}
                                backup={backup}
                                backupPrice={backupPrice}
                                backupselected={pricebackup?.isSelected}
                                postdiscount={postdiscount}
                                // pricepermonth={pricepermonth}
                                regions={selectedRegion}
                                // priceAdd={priceAdd}
                                hostname={hostname}
                                serverchose={serverchose}
                            />
                        </div>
                    </div>



                </div>

            </div>

        </>
    );
});

export default Parent; 